import * as api from '../api/partners';

// Actions Creators
export const getPartners = () => async (dispatch) => {
    try {
        const { data } = await api.fetchPartners();
        
        dispatch({ type: 'FETCH_ALL_PARTNER', payload: data });
        
    } catch (error) {
        console.log(error)
    }
}
    
export const createPartners = (partner) => async (dispatch) => {

    try {
        const { data } = await api.createPartners(partner);

        dispatch({ type: 'CREATE_PARTNER', payload: data });

    } catch (error) {
        console.log(error)
    }
}

export const updatePartner = (id, partner) => async (dispatch) => {
    try {
        const { data } = await api.updatePartner(id, partner);

        dispatch({ type: 'UPDATE_PARTNER', payload: data });

    } catch (error) {
        console.log(error)
    }
}

export const deletePartner = (id) => async (dispatch) => {
    try {
        await api.deletePartner(id);

        dispatch({ type: 'DELETE_PARTNER', payload: id });

    } catch (error) {
        console.log(error)
    }
}
